module.exports = {"vendorSheetName":"links","vendorSheetId":1,"reservationsSheetName":"reservations","reservationsSheetId":2,"settingsSheetName":"settings","settingsSheetId":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/sheetConstants.json
// module id = 74
// module chunks = 4